<template>
    <div id="sign">

    </div>
</template>

<script>
    export default {
        name: "Signin",
        computed : {
            getUserInfo() {
                return this.$store.getters.getUserInfo;
            },
        },
        methods:{
            signIn(){
                if(this.getUserInfo.id){
                    this.axios.post('/api/user/signIn').then(r => {
                        if(r.data.code){
                            this.$message.success(r.data.msg);

                        }else{
                            this.$message.error(r.data.msg);

                        }
                        this.$router.push('/')
                    })
                }else{
                    this.$router.push({name:'Login',query:{cburl:this.$route.path}})
                }

            }
        },created(){
            this.signIn();
        }
    }
</script>

<style lang="less">

</style>
